export const FETCH_SIMULATIONS = '/simulations/';
export const FETCH_SIMULATION = (id: string) => `/simulations/${id}`;
export const ADD_SIMULATION = '/simulations/add';
export const DOWNLOAD_STD_DEVS = '/simulations/stdevs/export';